import { commonjsGlobal, getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { __module as isSameOrAfter$1 } from '../../../_virtual/isSameOrAfter.js';

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)};}})); 
} (isSameOrAfter$1));

var isSameOrAfterExports = isSameOrAfter$1.exports;
const isSameOrAfter = /*@__PURE__*/getDefaultExportFromCjs(isSameOrAfterExports);

export { isSameOrAfter as default };
//# sourceMappingURL=isSameOrAfter.js.map
